"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var RednotAction_1 = require("./RednotAction");
function notifs(domain, action) {
    if (domain === void 0) { domain = []; }
    if (!action || !action.type)
        return domain;
    switch (action.type) {
        case RednotAction_1.NOTIF_SEND:
            return __spreadArrays([action.payload], domain.filter(function (_a) {
                var id = _a.id;
                return id !== action.payload.id;
            }));
        case RednotAction_1.NOTIF_DISMISS:
            return domain.filter(function (notif) { return notif.id !== action.payload; });
        case RednotAction_1.NOTIF_CLEAR:
            return [];
        default:
            return domain;
    }
}
exports.default = notifs;
//# sourceMappingURL=rednotReducer.js.map